import React, { useState, useEffect, useContext } from 'react';
import {Context} from '../contexts/StateContext';
import api from '../api';

//-----------------------------------------------------------
export function Api_Produtos(){
    const {state, dispatch} = useContext(Context);
    const {listaPesquisa} = state.parametros;
    const {inforProduto, inforCaixa, inforSaldoCredito} = state.produtos;
    
    const {evento, orcamento} = state.evento;
    const {dataFim, dataInicio, tipoOperacao, fornecedor} = inforProduto;

    const [buscaListaEntradas, setListaEntradas] = useState();
    const [buscaListaProd,setbuscaProd] = useState([]);
    const [buscaRelatorio, setRelatorio] = useState([]);
    const [buscaTodosCreditos, setListaCreditos] = useState([]);
    const [buscaListaSaidas, setListaSaidas] = useState([]);
    const [listaFornecedor, setFornecedor] = useState([]);
    const [buscaTagData, setTagData] = useState([]);    
    const [buscaTodosCaixa, setListaCaixa] = useState([]);

    //-----------------------------------------
    async function PesqCaixaTodos(){
        useEffect(() => {
            async function pesquisar(){
                await api.get(`Produtos/caixa/todos`) 
                .then(res => {
                    const buscar = res.data;
                    setListaCaixa(buscar);
                });
            };
            pesquisar();
        }, [inforCaixa.codigoAtualiza])
    
        return {buscaTodosCaixa}
    };
    //-----------------------------------------
    async function PesqCreditoTodos(){
        useEffect(() => {
            async function pesquisar(){
                await api.get(`Produtos/saldo/todos`) 
                .then(res => {
                    const buscar = res.data;
                    setListaCreditos(buscar);
    
                    dispatch({
                        type: 'set_saldoCredito',
                        payload: {
                            ...inforSaldoCredito, 
                            pesqSaldoCred:false
                        }
                    });
                });
            };
            pesquisar();
        }, [inforSaldoCredito.pesqSaldoCred])
    
        return {buscaTodosCreditos}
    };
    //----------------------------------------
    async function PesqProdutosTodos(){
        useEffect(() => {
            async function pesquisar(){
                await api.get(`Produtos/filtrarProdutos/todos`) 
                .then(res => {
                    const buscar = res.data;
                    setbuscaProd(buscar);
                    
                });

            };
            pesquisar();
        }, [inforProduto.pesqProduto, inforProduto.fornecedor])

        return {buscaListaProd}
    };
    //----------------------------------------
    async function PesqEntradasTodos(){
        useEffect(() => {
            async function pesquisar(){
                await api.get(`Produtos/entradas/todos`) 
                .then(res => {
                    const buscar = res.data;
                    setListaEntradas(buscar);
                    
                });

            };
            pesquisar();
        }, [inforProduto.fornecedor])

        return {buscaListaEntradas}
    };
    //----------------------------------------
    async function PesqSaidaTodos(){
        useEffect(() => {
            async function pesquisar(){
                await api.get(`Produtos/saidas/todos`) 
                .then(res => {
                    const buscar = res.data;
                    setListaSaidas(buscar);
                    
                });

            };
            pesquisar();
        }, [inforProduto.pesqProduto, inforProduto.fornecedor])

        return {buscaListaSaidas}
    };
    //-----------------------------------------
    async function PesqFornecedorTodos(){
        useEffect(() => {
            async function pesquisar(){
                await api.get(`Produtos/fornecedor/todos`) 
                .then(res => {
                    const buscar = res.data;
                    setFornecedor(buscar);
                    
                });

            };
            pesquisar();
        }, [inforProduto.fornecedor, inforProduto.novoFornecedor, inforSaldoCredito.fonteCredito, inforSaldoCredito.pesqSaldoCred])

        return {listaFornecedor}
    };
    //----------------------------------------
    async function PesquisarTipoTodos(){
        await api.get(`Produtos/Items/todos`) 
        .then(res => {
            const buscar = res.data;
            const xx = [];
            buscar.map(e=>{
                xx.push(e.tipo)
            });

            const DespLS = JSON.parse(localStorage.getItem(evento.placa));

            if(DespLS){
                const Ordenar = [...DespLS].sort((a, b)=> a.tipo.localeCompare(b.tipo));
                
                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: {
                        ...listaPesquisa,
                        listaItemLS: Ordenar,
                        listaTipoEvento: xx.length > 0 ? xx : []
                    }
                })    
            }       
        });
    };
    
    //----------------------------------------
    async function PesquisarTipoProd(tipo){
        await api.get(`Produtos/tipo/${tipo}`) 
        .then(res => {
            const buscar = res.data;
            if(buscar.length > 0){
                buscar.map(p => {
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload:{
                            ...listaPesquisa, 
                            listaItemProd: p.item,
                            
                        }
                    });   
                    dispatch({
                        type: 'set_Orcamento',
                        payload: {
                            ...orcamento, 
                            tipo: p.tipo,
                            nomeItem:  p.item[0],
                            novoTipo: "",
                            selectItem: "",
                            valorItem:"",
                            novoItem:""
                            
                        }
                    });
                })
            }
        });
    };
    
    //----------------------------------------
    async function PesqRelatorio(){
        useEffect(() => {
            if(tipoOperacao === "Compra"){
                async function pesquisar(){
                    await api.get(`Produtos/entrada/filtrarRelatorio/?fornecedor=${fornecedor}&dataIninio=${dataInicio}&dataFim=${dataFim}`) 
                    .then(res => {                
                        const buscar = res.data;
                        setRelatorio(buscar);
                    });
                };
                pesquisar();
            }else{setRelatorio([])};
                //----------
                if(tipoOperacao === "Venda" && dataInicio && dataFim){

                    async function pesquisar(){
                        await api.get(`Produtos/saida/filtrarRelatorio/?dataIninio=${dataInicio}&dataFim=${dataFim}`) 
                        .then(res => {                
                            const buscar = res.data;
                            setRelatorio(buscar);
                        });
                    };
                    pesquisar();
                }else{setRelatorio([])};
                
                
            }, [inforProduto.fornecedor, tipoOperacao, dataInicio, dataFim])

        return {buscaRelatorio}
    };
    //----------------------------------------
    async function PesqTagData(){
        useEffect(() => {     
            if(inforProduto.PesqData === 'hoje' && inforProduto.tipoOperacao){    
                async function pesquisar(){
                    await api.get(`Produtos/datahoje/?tipo=${inforProduto.tipoOperacao}`) 
                    .then(res => {                
                        const buscar = res.data;
                        if(buscar.length > 0){
                            setTagData(buscar);
                        }
                    });
                };
                pesquisar();
            }
            if(inforProduto.PesqData === 'ontem'){    
                async function pesquisar(){
                    await api.get(`Produtos/dataOntem/?tipo=${inforProduto.tipoOperacao}`) 
                    .then(res => {                
                        const buscar = res.data;
                        if(buscar.length > 0){
                            setTagData(buscar);
                        }
                    });
                };
                pesquisar();
            }
            if(inforProduto.PesqData === 'semanaAtual'){    
                async function pesquisar(){
                    await api.get(`Produtos/destaSemana/?tipo=${inforProduto.tipoOperacao}`) 
                    .then(res => {                
                        const buscar = res.data;
                        if(buscar.length > 0){
                            setTagData(buscar);
                        }
                    });
                };
                pesquisar();
            }
            if(inforProduto.PesqData === 'mesAtual'){   
                async function pesquisar(){
                    await api.get(`Produtos/desteMes/?tipo=${inforProduto.tipoOperacao}`) 
                    .then(res => {                
                        const buscar = res.data;
                        if(buscar.length > 0){
                            setTagData(buscar);
                        }
                    });
                };
                pesquisar();
            }
            if(inforProduto.PesqData === 'mesPassado'){    
                async function pesquisar(){
                    await api.get(`Produtos/mesPassado/?tipo=${inforProduto.tipoOperacao}`) 
                    .then(res => {                
                        const buscar = res.data;
                        if(buscar.length > 0){
                            setTagData(buscar);
                        }
                    });
                }
                pesquisar();
            }else{
                setTagData([])
            }
        }, [inforProduto.PesqData, inforProduto.tipoOperacao])

    return {buscaTagData}
};


return{PesqCaixaTodos, PesqTagData, PesqRelatorio, PesqCreditoTodos, PesquisarTipoTodos,
    PesqEntradasTodos, PesqProdutosTodos, PesqSaidaTodos, PesqFornecedorTodos, PesquisarTipoProd}
};

// 
// 




